<div  class=" min-h-screen flex flex-col justify-center items-center gap-10 w-screen" style="background-color: #1E1E1E;">


      <img @slideDownUp [src]="bgUrl" width="100vw" />
  
  
      <router-outlet></router-outlet>
  

</div>

